import { render, staticRenderFns } from "./StoreLabel.vue?vue&type=template&id=246097c6&scoped=true&"
import script from "./StoreLabel.vue?vue&type=script&lang=ts&"
export * from "./StoreLabel.vue?vue&type=script&lang=ts&"
import style0 from "./StoreLabel.vue?vue&type=style&index=0&id=246097c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246097c6",
  null
  
)

export default component.exports